// src/pages/Profile.js
// Page profil utilisateur - NE PAS MODIFIER

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/shared/LanguageSwitcher';
import { APP_CONFIG } from '../constants/config';

const Profile = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const menuItems = [
    { icon: '⚙️', label: t('common.settings'), path: '/settings' },
    { icon: '💬', label: t('nav.messages'), path: '/messages' },
    { icon: '🔔', label: t('common.info'), path: '/notifications' },
    { icon: '❓', label: t('common.help'), path: '/support' },
  ];

  const handleWhatsAppSupport = () => {
    const phone = APP_CONFIG.SUPPORT_WHATSAPP.replace(/\D/g, '');
    window.open(`https://wa.me/${phone}`, '_blank');
  };

  const styles = {
    container: { display: 'flex', flexDirection: 'column', minHeight: '100vh' },
    header: {
      padding: '16px',
      position: 'sticky',
      top: 0,
      backgroundColor: '#0A0E1A',
      zIndex: 50,
      borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    },
    title: { fontSize: '22px', fontWeight: '700', color: '#FFFFFF' },
    profileCard: {
      margin: '16px',
      padding: '24px',
      backgroundColor: '#162033',
      borderRadius: '16px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '12px',
      border: '1px solid rgba(255, 255, 255, 0.1)',
    },
    avatar: {
      width: '72px',
      height: '72px',
      borderRadius: '50%',
      backgroundColor: 'rgba(255, 215, 0, 0.15)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '32px',
    },
    guestName: { fontSize: '18px', fontWeight: '600', color: '#FFFFFF' },
    guestText: { fontSize: '13px', color: '#A0AEC0', textAlign: 'center' },
    loginButton: {
      marginTop: '8px',
      padding: '12px 32px',
      backgroundColor: '#FFD700',
      border: 'none',
      borderRadius: '10px',
      color: '#0A0E1A',
      fontSize: '14px',
      fontWeight: '700',
      cursor: 'pointer',
    },
    section: {
      padding: '8px 16px',
      display: 'flex',
      flexDirection: 'column',
      gap: '4px',
    },
    sectionTitle: {
      fontSize: '13px',
      fontWeight: '600',
      color: '#4A5568',
      textTransform: 'uppercase',
      padding: '8px 0',
    },
    menuItem: {
      display: 'flex',
      alignItems: 'center',
      gap: '12px',
      padding: '14px',
      backgroundColor: '#162033',
      borderRadius: '10px',
      cursor: 'pointer',
      border: '1px solid rgba(255, 255, 255, 0.05)',
      transition: 'background-color 200ms',
    },
    menuIcon: { fontSize: '20px' },
    menuLabel: { flex: 1, fontSize: '15px', color: '#FFFFFF' },
    menuArrow: { color: '#4A5568', fontSize: '18px' },
    languageRow: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '14px',
      backgroundColor: '#162033',
      borderRadius: '10px',
      border: '1px solid rgba(255, 255, 255, 0.05)',
    },
    version: {
      textAlign: 'center',
      fontSize: '12px',
      color: '#4A5568',
      padding: '24px',
    },
  };

  return (
    <div style={styles.container}>
      <Helmet>
        <title>Mon profil | Fynho</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <div style={styles.header}>
        <div style={styles.title}>👤 {t('nav.profile')}</div>
      </div>

      <div style={styles.profileCard}>
        <div style={styles.avatar}>👤</div>
        <div style={styles.guestName}>Invité</div>
        <div style={styles.guestText}>
          Connectez-vous pour sauvegarder vos favoris et suivre vos réservations
        </div>
        <button style={styles.loginButton} onClick={() => navigate('/login')}>
          Se connecter
        </button>
      </div>

      <div style={styles.section}>
        <div style={styles.sectionTitle}>Paramètres</div>
        <div style={styles.languageRow}>
          <span style={styles.menuLabel}>🌍 {t('common.language')}</span>
          <LanguageSwitcher compact />
        </div>
        {menuItems.map((item, index) => (
          <div
            key={index}
            style={styles.menuItem}
            onClick={() => navigate(item.path)}
            onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#1C2537')}
            onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#162033')}
          >
            <span style={styles.menuIcon}>{item.icon}</span>
            <span style={styles.menuLabel}>{item.label}</span>
            <span style={styles.menuArrow}>›</span>
          </div>
        ))}
      </div>

      <div style={styles.section}>
        <div style={styles.sectionTitle}>Support</div>
        <div
          style={styles.menuItem}
          onClick={handleWhatsAppSupport}
          onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = '#1C2537')}
          onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = '#162033')}
        >
          <span style={styles.menuIcon}>💬</span>
          <span style={styles.menuLabel}>Contacter le support WhatsApp</span>
          <span style={styles.menuArrow}>›</span>
        </div>
      </div>

      <div style={styles.version}>
        Fynho v{APP_CONFIG.APP_VERSION}
      </div>
    </div>
  );
};

export default Profile;